var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17.602 19.553"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.602 6.533v13.02h-7.217v-7.035H7.217v7.035H0V6.533L8.8 0zM8.74 1.767l-.06.045-7.199 5.35-.04.03-.04.03v10.954h4.414v-7.034h5.971v7.034H16.2V7.222l-.039-.03-.04-.03-7.201-5.35-.059-.045-.06-.045z"
  })));
};
export default SvgHome;